<template>
    <section
        class="auth-page-wrapper py-5 position-relative d-flex align-items-center justify-content-center min-vh-100">
        <BContainer>


            <div class="row">
                <div class="card mb-0 col-9 offset-2  p-0">
                    <!---->
                     <img v-if="false" src="@/assets/images/noel-rena.png" style="position: absolute; height: auto; top: -6.5em; z-index: 999999; display: inline-block; min-width: 200px; max-width: 200px; width: 200px; margin-left: 11em;" />
                    <div class="row g-0 align-items-center " style="    height: 50em;">
                        <div class="col-xxl-6"  style="height: 100%;background-image: url(https://transferporto.s3.amazonaws.com/cdn/img/ship.jpeg); background-size: cover; background-position-x: -5em;">


                        </div>
                        <div class="col-xxl-6 ">
                                <div class="text-center">
                                    <img src="@/assets/images/logo-dark.png" class="m3 me-2" alt="" height="30">
                                </div>
                            <div class="card mb-0 border-0 shadow-none mb-0">
                                <div class="text-center mt-5">

                                    <h5 class="fs-3xl">Acesso ao sistema</h5>
                                    <h5 class="text-muted" v-if="step == 2">{{ dto_company.name }}</h5>
                                </div>
                                <div class="card-body p-sm-4 ">
                                
                                    <div class="p-2 mt-1">
                                            <div class="mb-2" v-if="step == 1">
                                                <div class="float-end">
                                                    <span v-if="step == 2" style="cursor:pointer" class="text-muted"
                                                        @click="dto_company = {}; step = 1; dto_login.companyId = ''"><i
                                                            class="ri-exchange-line"></i> Trocar de CNPJ</span>
                                                </div>
                                                
                                                <label for="document" class="form-label">CNPJ</label>
                                                <div class="position-relative">
                                                    <input id="document" v-mask-cnpj v-model="dto_login.document"
                                                        :disabled="step == 2" class="form-control" type="text"
                                                        placeholder="">
                                                </div>
                                            </div>
                                            <span class="text-danger"
                                                v-if="error == 'COMPANY_ACCOUNT_NOT_FOUND'">Agência não
                                                cadastrada</span>

                                            <div class="mb-2" v-if="step == 2">
                                                <label for="username" class="form-label">Usuário</label>
                                                <div class="position-relative">
                                                <Dropdown v-model="dto_login.login"  optionValue="_id"  :options="loginInfo.users" placeholder="- Selecione seu usuário -" class="w-full w100" style="width:100%" :disabled="disabled">
                                                    <template #option="slotProps">
                                                        <img :src='`${$store.state.session.apiUrl}/user/${slotProps.option._id}/avatar`' class="avatar-xxs rounded-circle me-2"> {{ slotProps.option.name}}
                                                    </template>
                                                    <template #value="slotProps" v-if="dto_login.login">
                                                        <img  :src='`${$store.state.session.apiUrl}/user/${loginInfo.users.find(u=>u._id == slotProps.value)._id}/avatar`' class="avatar-xxs rounded-circle me-2"> {{   loginInfo.users.find(u=>u._id == slotProps.value).name }}
                                                    </template>
                                                </Dropdown>

                                                </div>
                                            </div> 

                                            <div class="mb-3" v-if="step == 2">
                                                <div class="float-end">
                                                    <a href="/public/forgotAccess" v-if="false" class="text-muted">Esqueci
                                                        minha senha</a>
                                                </div>
                                                <label class="form-label" for="password-input">Senha</label>
                                                <div class="position-relative">
                                                    <input id="password" v-model="dto_login.password"
                                                        class="form-control" type="password" placeholder="">
                                                </div>
                                            </div>




                                            <div class="form-check" v-if="step == 2">
                                                <input class="form-check-input" type="checkbox" id="auth-remember-check"
                                                    value="">
                                                <label class="form-check-label" for="auth-remember-check">Gravar
                                                    dados</label>
                                            </div>


                                            <div class="mt-2" v-if="error == 'COMPANY_ACCOUNT_PENDING'">
                                                <div class="alert alert-info alert-border-left">
                                                    <i class=" ri-time-line me-3 align-middle fs-lg"></i><strong>Cadastro
                                                        em análise</strong> <br>
                                                    Seu cadastro está em análise. Aguarde mais alguns instantes que logo
                                                    mais enviaremos um email com novidades!
                                                    <br><br>Qualquer dúvida, pode chamar no whats 19 99461-8103.
                                                </div>
                                            </div>
                                            <div class="mt-2" v-if="error == 'ACCOUNT_NOT_APPROVED'">
                                                <div class="alert alert-warning alert-border-left">
                                                    <i class=" ri-alert-fill me-3 align-middle fs-lg"></i><strong>Cadastro
                                                        não aprovado</strong> <br>
                                                    Houve algum erro na análise do seu cadastro e infelizmente não foi
                                                    possível aprovar o acesso neste momento.
                                                    <br><br>Qualquer dúvida, pode chamar no whats 19 99461-8103.
                                                </div>
                                            </div>
                                            <div class="mt-4">
                                                <button class="btn btn-sm btn-outline-info disabled btn-load w-100 p-2"
                                                    v-if="loading">
                                                    <span class="d-flex align-items-center"><span class="spinner-border"
                                                            aria-hidden="true">
                                                        </span><span class="flex-grow-1 ms-2"> Carregando... </span>
                                                    </span>
                                                </button>
                                                <button class="btn btn-md btn-transfer w-100" 
                                                    @click="step == 1 ? preLogin() : login()" v-if="!loading">Acessar
                                                </button>
                                            </div>
                                    
                                        <div class="text-center mt-5" v-if="step == 1">
                                            <p class="mb-0"> É seu primeiro acesso?
                                                <router-link to="/public/register"
                                                    class="fw-semibold text-secondary text-decoration-underline">
                                                    Cadastrar agência
                                                </router-link>
                                            </p>
                                        </div>

                                        <div class="text-center mt-3">
                                            <p class="mb-0">Esqueceu sua senha?
                                                <router-link to="/public/forgotAccess"
                                                    class="fw-semibold text-secondary text-decoration-underline">
                                                    Redefinir
                                                </router-link>
                                            </p>
                                        </div>
                                        <div class="text-center mt-3" v-if='step == 2'> 
                                            <p class="mb-0">
                                                <button class='btn btn-sm btn-body' @click="erease">
                                                    <i class="mdi mdi-logout text-muted fs-lg align-middle me-1"></i>
                                                    Trocar de CNPJ
                                                </button>
                                            </p>
                                        </div>
                                        <hr>
                                        <div class="text-center mt-3">
                                            <p class="mb-0">É passageiro? 
                                                <a href="https://wa.me/5519994618103?text=Ol%C3%A1%2C+tenho+uma+d%C3%BAvida+referente+ao+Transfer"
                                                    class="fw-semibold text-secondary text-decoration-underline">
                                                    Envie uma mensagem
                                                </a>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <!---->
                                <!---->
                            </div>
                        </div>
                    </div>
                    <!---->
                    <!---->
                </div>
            </div>

        </BContainer>

    </section>

    <footer class="footer p-2" style="left: 0;">
        <div class="container-fluid">
            <div class="row">
                <div class="col-sm-6 col">
                    <img src="@/assets/images/logo-dark.png" class=" me-2" alt="" height="15" />
                    2025 © Transfer Porto - versão {{ $store.state.session.version }} 
                </div>
                <div class="col-sm-6 col">
                    <div class="text-sm-end d-none d-sm-block">Desenvolvido por <a href="https://www.favatec.com.br/">favatec</a> </div>
                </div>
            </div>
        </div>
    </footer>
</template>


<script>
import Dropdown from 'primevue/dropdown';
import UserMixing from '@/mixings/UserMixing'
import Messages from '@/mixings/Messages';
import CompanyMixing from '@/mixings/CompanyMixing'
import UtilMixing from '@/mixings/UtilMixing';

export default {
    mixins: [UtilMixing, Messages, CompanyMixing, UserMixing],
    components: { Dropdown },
    data() {
        return {
            loginInfo : { },
            step: 1,
            error: '',
            loading: false,
            validCnpj: false,
            loadingZip: false,
            dto_company: {},
            dto_login: {
                document: '',
                login: null,
                companyId: '',
                password: ''
            }
        };
    },
    methods: {
        async login() {
            try {
                this.error = '';
                this.loading = true;
                const { data } = await UserMixing.login(this.dto_login);
                this.$store.commit('setLogin', { jwt: data.jwt, refreshToken: data.refreshToken, sessionId: data.sessionId, role: data.role });
                this.$router.push('/internal/dashboard');
                localStorage.setItem('trp-prelogin_user', this.dto_login.login);
            } catch (e) {
                if (e.fromApi) {
                    this.error = e.http_body.type;
                    Messages.toast_warning(e);
                } else {
                    Messages.toast_error(e);
                }
            } finally {
                this.loading = false;
            }
        },
        erease(){
            this.dto_company = {}; 
            this.step = 1; 
            localStorage.removeItem('trp-prelogin_user');
            localStorage.removeItem('trp-prelogin');
            this.dto_login.companyId = '';
            this.dto_login.login = '';
        },
        async preLogin() {
            try {
                this.error = '';
                this.loading = true;
                if (!UtilMixing.isCnpjValid(this.dto_login.document)) {
                    Messages.toast_warning('Informe um CNPJ Válido.');
                    return;
                }
                const { data } = await CompanyMixing.preLogin(this.dto_login.document);
                this.loginInfo = data;
                localStorage.setItem('trp-prelogin', JSON.stringify(data));
                this.step = 2;
                this.dto_company = data;
                this.dto_login.companyId = data._id;
                if(this.loginInfo.users.length > 0){

                    if(this.dto_login.login == null || this.dto_login.login == '')

                        this.dto_login.login = this.loginInfo.users[0]._id;
                }
            } catch (e) {
                if (e.fromApi) {
                    this.error = e.http_body.type;
                    Messages.toast_warning(e);
                } else {
                    Messages.toast_error(e);
                }
            } finally {
                this.loading = false;
            }
        },
    },
    created(){
        var isLogged = this.$store.state.session.logged;

        if(isLogged){
            Messages.toast_success('Usuário já logado.');
            this.$router.push('/internal/dashboard');
        }
        var preLogin = JSON.parse(localStorage.getItem('trp-prelogin'));
        if(preLogin){
            this.step = 2;
            this.loginInfo = preLogin;
            this.dto_company = preLogin;
            this.dto_login.companyId = preLogin._id;
            this.dto_login.document = preLogin.document;
            this.dto_login.login = localStorage.getItem('trp-prelogin_user');
            this.preLogin();
        }
    },
    beforeCreate() {
        document.documentElement.setAttribute('data-theme', 'default');
    },
};
</script>